import { render, staticRenderFns } from "./other-staff-wap.vue?vue&type=template&id=24c299b4"
import script from "./other-staff-wap.vue?vue&type=script&lang=js"
export * from "./other-staff-wap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports